module.exports = __webpack_public_path__ + "static/media/vu.4acd098a.svg";